import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'taskHasAssignedPriority',
})
export class TaskHasAssignedPriorityPipe implements PipeTransform {
  transform(priority: string): boolean {
    return !!priority && priority !== 'None';
  }
}
